import { useEffect, useState, useCallback } from "react";

interface SWState {
  isInstalled: boolean;
  isUpdateAvailable: boolean;
  registration: ServiceWorkerRegistration | null;
}

export function useServiceWorker() {
  const [state, setState] = useState<SWState>({
    isInstalled: false,
    isUpdateAvailable: false,
    registration: null,
  });

  const update = useCallback(() => {
    if (state.registration?.waiting) {
      state.registration.waiting.postMessage("SKIP_WAITING");
      window.location.reload();
    }
  }, [state.registration]);

  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

    if (import.meta.env.DEV) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((r) => r.unregister());
      });
      return;
    }

    let reg: ServiceWorkerRegistration;

    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        reg = registration;
        setState((s) => ({ ...s, registration, isInstalled: true }));

        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              setState((s) => ({ ...s, isUpdateAvailable: true }));
            }
          });
        });
      })
      .catch((err) => {
        console.warn("SW registration failed:", err);
      });

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }, []);

  return { ...state, update };
}
